// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { HorizontalBar, defaults, Bar } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";
import { mediaQueries } from "../../shared/config";

const barChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: true
  },
  scales: {
    xAxes: [
      {
        display: true,
        position: "bottom",
        scaleLabel: {
          display: true,
          labelString: "Race/Ethnicity"
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          //set the labels to stack when they're too long
          //so they don't overflow out of the card
          callback: function(label) {
            if (/\s/.test(label)) {
              if (label.split(" ").length > 2) {
                label = label.split(" ");
                label[1] = label[0] + " " + label[1];
                label.shift();
                return label;
              } else {
                return label.split(" ");
              }
            } else {
              return label;
            }
          }
        },
        stacked: false,
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Percent of Students who Identify"
        }
      }
    ]
  },
  title: {
    display: false,
    text: "UCLA vs. Daily Bruin Race/Ethnicity Breakdown"
  },
  tooltips:{
    callbacks:{
      label: function(tooltipItem){
        return this._data.datasets[tooltipItem.datasetIndex].label +': ' + tooltipItem.yLabel + '%';
      }
    }
  }
};

interface EthnicitySectionBreakdownProps{
  caption: Array<string>;
}

class EthnicitySectionBreakdownBarChartCard extends React.Component <EthnicitySectionBreakdownProps>{
  constructor(props:EthnicitySectionBreakdownProps){
    super(props);
  }
  state = {
    labels: ["Black or African American",
          "White",
          "Hispanic or Latino",
          "Native American or American Indian",
          "Asian/Pacific Islander",
          "Multiracial",
          "Prefer not to say",
          "Middle Eastern"],
          datasets: [
            {
              data: [
                2.4,
                33.3,
                4.8,
                0,
                40.5,
                11.9,
                4.8,
                2.4
              ],
              backgroundColor: "#0080C6",
              label: "Editors"
            },
            {
              data: [
                2.9,
                25.7,
                5.7,
                0,
                45.7,
                14.3,
                0,
                5.7
              ],
              backgroundColor: "#c377e0",
              label: "Paid staff",
            },
            {
              data: [
                2.6,
                28.9,
                5.3,
                0,
                50.0,
                5.3,
                2.6,
                5.3
              ],
              backgroundColor: "#56B9EF",
              label: "Unpaid contributors",
            },
            {
              data: [
                1.0,
                21.8,
                12.9,
                0,
                43.6,
                14.9,
                3.0,
                3.0
              ],
              backgroundColor: "#733B90",
              label: "Fall 2022 interns",
            },
          ]
        };

  render() {
    const { mobile } = mediaQueries;
    defaults.global.defaultFontColor = "#0a0a0a";
    const caption = this.props.caption;
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            ${mobile} {
              font-size: 18px;
            }
          `}
        >
          Staff level race/ethnicity breakdowns
        </div>
        <div
          className={css`
            height: 500px;
            ${mobile} {
              height: 600px;
            }
            width: 100%;
          `}
        >
          <Bar
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
        </div>
        <div className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: left;
          `}>
          {caption}
          </div>
      </Card>
    );
  }
}

export default EthnicitySectionBreakdownBarChartCard;
